'use strict';

angular.module('TurneroApp').component('coCiudadano', {
    bindings: {
        usuario: '<'
    },
    controller: [
        '$scope',
        '$rootScope',
        '$state',
        '$mdDialog',
        'rolesService',
        'utilsService',
        'TurneroAppConstant',
        '$interval',
        'generalService',
        '$location',
        'miDoctaModoService',
        function ($scope, $rootScope, $state, $mdDialog, rolesService, utilsService, TurneroAppConstant, $interval, generalService, $location, miDoctaModoService) {
            var ctrl = this;
            ctrl.modoRestringidoClienteMiDocta = false;
            try {
                var modoQ = $location.search()[TurneroAppConstant.integracionMiDocta.queryParamModoCliente];
                if (modoQ === '1' || modoQ === 'true' || modoQ === 'S' || modoQ === 's') {
                    sessionStorage.setItem(TurneroAppConstant.integracionMiDocta.sessionStorageKeyModoCliente, '1');
                } else if (modoQ === '0' || modoQ === 'false' || modoQ === 'N' || modoQ === 'n') {
                    sessionStorage.removeItem(TurneroAppConstant.integracionMiDocta.sessionStorageKeyModoCliente);
                }
                if (sessionStorage.getItem(TurneroAppConstant.integracionMiDocta.sessionStorageKeyModoCliente) === '1') {
                    ctrl.modoRestringidoClienteMiDocta = true;
                    $rootScope.modoRestringidoClienteMiDocta = true;
                } else {
                    $rootScope.modoRestringidoClienteMiDocta = false;
                }
            } catch (e) {
                $rootScope.modoRestringidoClienteMiDocta = false;
            }
            //Obtiene el state de la url para saber si viene Turnero o si viene de algun enlace externo (Portal de Tramites)
            ctrl.layoutState = $state.$current.name.split('.')[0];
            //se define el href Padre
            ctrl.urlRedirect = ctrl.layoutState == 'ciudadanoPortal' ? 'turnosPortal' : 'turnos';

            ctrl.pantallaCalendario = false;
            ctrl.pantallaPrincipal = true;
            ctrl.pantallaTasaRetributiva = false;
            ctrl.tramite_Seleccionado = null;
            ctrl.urlEnNombreTramite = null;
            ctrl.centro_Seleccionado = null;
            ctrl.mostrarAdmin = false;

            ctrl.esChromeMidoctaListado = function () {
                var nombre = $state.current && $state.current.name;
                return nombre === 'ciudadano.tramites' || nombre === 'ciudadanoPortal.tramites'
                    || nombre === 'ciudadano.centrosatencion' || nombre === 'ciudadanoPortal.centrosatencion'
                    || nombre === 'ciudadano.tramitealternativa' || nombre === 'ciudadanoPortal.tramitealternativa';
            };

            ctrl.esPantallaTramiteAlternativa = function () {
                var nombre = $state.current && $state.current.name;
                return nombre === 'ciudadano.tramitealternativa'
                    || nombre === 'ciudadanoPortal.tramitealternativa';
            };

            ctrl.esPantallaMisTurnos = function () {
                var nombre = $state.current && $state.current.name;
                return nombre === 'ciudadano.misturnos'
                    || nombre === 'ciudadanoPortal.misturnos';
            };

            // Extrae URL completa embebida en N_Tramite (ej. formularios obligatorios en prod).
            // Se usa solo para el href; el texto visible se trunca por CSS.
            ctrl.actualizarUrlEnNombreTramite = function (tramite) {
                ctrl.urlEnNombreTramite = null;
                var nombre = tramite && tramite.N_Tramite ? tramite.N_Tramite : '';
                var match = nombre.match(/https:\/\/\S+/i);
                if (match) {
                    ctrl.urlEnNombreTramite = match[0];
                }
            };

            ctrl.timer = {
                //inicio: moment().toDate(),
                counter: 0
            }

            ctrl.cancelTimer = function () {
                ctrl.timer.counter = 2;
                $interval.cancel(ctrl.timer.counter);
            }
            $scope.$on('cancelIntervalLoading', function (event, bool) {
                ctrl.cancelTimer();

            });

            ctrl.Regresar = function () {
                $rootScope.$broadcast('esHome', true);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                $rootScope.btnConoceCentro = false;
                ctrl.tramite_Seleccionado = null;
                ctrl.actualizarUrlEnNombreTramite(null);
                ctrl.centro_Seleccionado = null;
                ctrl.AgendasXCentro = [];
                $rootScope.Id_Centro_Atencion = null;
            };

            ctrl.calcTiempoLoading = function () {
                if (ctrl.timer.counter < 2) {
                    ctrl.timer.counter++;
                    /*var fecha1 = moment(ctrl.timer.inicio, "YYYY-MM-DD HH:mm:ss");
                    ctrl.timer.counter = moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(fecha1, 's');*/
                    swal.close();

                } else {
                    $interval.cancel(ctrl.timer.counter);
                }

            };
            $interval(ctrl.calcTiempoLoading, 500);

            ctrl.$onInit = function () {
                ctrl.tieneRol();
                ctrl.getVersion();
                ctrl.getServer();
            }

            ctrl.$onChanges = function () {
                swal.close();
                $mdDialog.destroy();
            };

            ctrl.tieneRol = function () {
                if (miDoctaModoService.estaActivo()) {
                    ctrl.mostrarAdmin = false;
                    return;
                }
                rolesService.getTieneRol().$promise.then(function (data) {

                    if (data.results === 1 && !ctrl.modoRestringidoClienteMiDocta) {
                        ctrl.mostrarAdmin = true;
                    }
                    else {
                        ctrl.mostrarAdmin = false;
                    }
                });
            }

            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                     if (resultado) {
                         ctrl.version = resultado.Version;
                         ctrl.entorno = resultado.Entorno;
                         TurneroAppConstant.vedi.url = resultado.VeDiUrl;
                         TurneroAppConstant.vedi.veDiIdAplicacion = resultado.VeDiIdAplicacion;
                         TurneroAppConstant.vedi.ciDiUrlRelacion = resultado.CiDiUrlRelacion;
                     }
                })                
            }
            
            

            ctrl.getServer = function () {

                generalService.Get_Server_Id().$promise.then(function (resultado) {
                    ctrl.server = resultado.Data;
                }).catch(function (error) {

                })
            }

            

            ctrl.cambiarSeleccionado = function (seccion) {
                ctrl.AgendasXCentro = [];
                ctrl.pantallaCalendario = false;
                ctrl.pantallaPrincipal = false;
                ctrl.pantallaTasaRetributiva = false;
                
                if (seccion == 'Tramite') {
                    if ($rootScope.btnConoceCentro) {
                        ctrl.centro_Seleccionado.agenda_Seleccionada = null;
                    } else {
                        ctrl.centro_Seleccionado = null;
                    }                    
                    ctrl.tramite_Seleccionado = null;
                    ctrl.actualizarUrlEnNombreTramite(null);
                } else if (seccion == 'Centro') {
                    ctrl.centro_Seleccionado = null;
                    ctrl.tramite_Seleccionado = !$rootScope.btnConoceCentro ? ctrl.tramite_Seleccionado :
                        { Id_Tramite: null, Id_Tramite_Relevado: null, Id_Tramite_Aplicacion: null, N_Tramite: "", N_Unidad_Tramite: "", Telefono: null, Url: "" };
                    ctrl.actualizarUrlEnNombreTramite(ctrl.tramite_Seleccionado);
                }
            }

            ctrl.mostrarTasasHistorico = function () {
                ctrl.AgendasXCentro = [];
                ctrl.centro_Seleccionado = null;
                ctrl.tramite_Seleccionado = null;
                ctrl.actualizarUrlEnNombreTramite(null);
                $rootScope.$broadcast('esTasaRetributiva', true);
                $state.go('ciudadano.tasashistorico');
            }

            $scope.$on('esHome', function (event, bool) {
                ctrl.pantallaPrincipal = bool;
            });

            $scope.$on('regresarDesdeMisTurnos', function () {
                ctrl.Regresar();
            });

            $scope.$on('esCalendario', function (event, bool) {
                if (bool) {
                    $rootScope.$broadcast('esHome', false)
                }
                ctrl.pantallaCalendario = bool;
                if (bool) {
                    if (ctrl.tramite_Seleccionado && ctrl.centro_Seleccionado && ctrl.centro_Seleccionado.agenda_Seleccionada) {
                        $rootScope.$broadcast('cambioAgenda', ctrl.centro_Seleccionado.agenda_Seleccionada.id, ctrl.tramite_Seleccionado);
                    } else if (ctrl.tramite_Seleccionado != null) {
                        $state.go('ciudadano.tramites');
                    } else {
                        $state.go('ciudadano.centrosatencion');
                    }
                }
            });

            $scope.$on('seleccionarTramite', function (event, tramite, limpiarCentro = true) {
                ctrl.tramite_Seleccionado = tramite;
                ctrl.actualizarUrlEnNombreTramite(tramite);
                if (limpiarCentro) {
                    ctrl.centro_Seleccionado = null;
                    ctrl.verPantallaCentros();
                }
            });

            $scope.$on('esTasaRetributiva', function (event, bool) {
                ctrl.pantallaTasaRetributiva = bool;
                if (bool) {
                    $rootScope.$broadcast('esHome', false);
                    $rootScope.$broadcast('esCalendario', false);
                }
            });

            $scope.$on('seleccionarCentro', function (event, centroAtencion) {
                ctrl.centro_Seleccionado = centroAtencion;
            });

            $scope.$on('seleccionarAgenda', function (event, agendaSeleccionada, Agendas) {
                ctrl.centro_Seleccionado.agenda_Seleccionada = agendaSeleccionada;
                ctrl.AgendasXCentro = Agendas;
                $state.go(ctrl.layoutState + '.calendario');

            });

            $scope.$on('seleccionarTurno', function (event, dataTurno) {
                if (dataTurno != null) {
                    ctrl.Turno = {
                        Datos: dataTurno,
                        Centro: ctrl.centro_Seleccionado,
                        Tramite: ctrl.tramite_Seleccionado
                    };

                    $rootScope.TurnoDetalle = ctrl.Turno;
                    $rootScope.$broadcast('confirmarTurno', ctrl.Turno)
                }
            })

            $scope.$on('getTramiteSeleccionado', function (event) {
                if (ctrl.tramite_Seleccionado != null) {
                    ctrl.verPantallaCentros();
                } else {
                    $state.go(ctrl.layoutState + '.tramites');
                }
            });

            ctrl.verPantallaCentros = function () {
                $rootScope.$broadcast('centrosLoad', ctrl.tramite_Seleccionado)
            }

            //cambiar Agenda
            ctrl.actualizarAgenda = function () {
                ctrl.Agenda = ctrl.AgendasXCentro;
                $mdDialog.show({
                    template: require('../../turnos/turnosOnline/modalSeleccioneAgenda.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: false, // Only for -xs, -sm breakpoints.,
                    controllerAs: '$ctrl',
                    controller: function () {
                        return ctrl;
                    }
                });
            }

            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
            };

            ctrl.cambiarAgenda = function (agenda) {
                if (ctrl.agendaSeleccionada != null && ctrl.agendaSeleccionada != undefined) {
                    ctrl.centro_Seleccionado.agenda_Seleccionada = ctrl.agendaSeleccionada
                    ctrl.cerrarModal();
                    $rootScope.$broadcast('cambioAgenda', ctrl.centro_Seleccionado.agenda_Seleccionada.id, ctrl.tramite_Seleccionado)

                } else {
                    sweetAlert("Debe seleccionar una agenda de la opciones", '', "warning");
                }
            }
        }],
    template: require('./ciudadano.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/ciudadano/ciudadanoComponent.js